// This is the single bridge to the existing JavaScript HTTP helpers.
// @ts-expect-error The legacy HTTP module has no TypeScript declarations.
import { downloadAuthenticatedFile, makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import type { ApiError, ApiResult, ProductSearchPage, QaReport, ReportKind, ReportParameters, SelectOption } from "./qaReportTypes";

type LegacyResult = { success?: boolean; data?: unknown; errorStatus?: number };
function normalize<T>(result: LegacyResult): ApiResult<T> {
  if (result.success) return { success: true, data: result.data as T };
  const data = result.data && typeof result.data === "object" ? result.data as ApiError : {};
  return { success: false, data, errorStatus: result.errorStatus ?? data.errorStatus };
}

async function get<T>(endpoint: string): Promise<ApiResult<T>> {
  return normalize<T>(await makeGetApiCall(endpoint));
}
async function post<T>(endpoint: string, payload: unknown): Promise<ApiResult<T>> {
  return normalize<T>(await makePostApiCall(endpoint, payload));
}

export const qaReportsApi = {
  products: (query: string, page: number) => get<ProductSearchPage>(`qa-report-products?q=${encodeURIComponent(query.trim())}&page=${page}`),
  options: (endpoint: "categoriesForDropdown" | "classesForDropdown" | "suppliersForDropdown") => get<SelectOption[]>(endpoint),
  history: () => get<{ data: QaReport[] }>("qa-report-requests?per_page=50"),
  status: (url: string) => get<QaReport>(url),
  submit: (kind: ReportKind, parameters: ReportParameters) => post<QaReport>("qa-report-requests", { report_type: kind, parameters }),
  generateLegacy: (endpoint: string, parameters: ReportParameters) => post<{ location: string }>(endpoint, { filter: parameters }),
  retry: (id: string) => post<QaReport>(`qa-report-requests/${id}/retry`, {}),
  download: async (report: QaReport): Promise<ApiResult<void>> => normalize<void>(await downloadAuthenticatedFile(
    report.download_url,
    report.output_name || `${report.report_name || "report"}.pdf`,
  )),
};
